/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { GovKoRosreestrIcon16Light } from './GovKoRosreestrIcon16Light';
import { GovKoRosreestrIcon16Regular } from './GovKoRosreestrIcon16Regular';
import { GovKoRosreestrIcon16Solid } from './GovKoRosreestrIcon16Solid';
import { GovKoRosreestrIcon20Light } from './GovKoRosreestrIcon20Light';
import { GovKoRosreestrIcon20Regular } from './GovKoRosreestrIcon20Regular';
import { GovKoRosreestrIcon20Solid } from './GovKoRosreestrIcon20Solid';
import { GovKoRosreestrIcon24Regular } from './GovKoRosreestrIcon24Regular';
import { GovKoRosreestrIcon24Solid } from './GovKoRosreestrIcon24Solid';
import { GovKoRosreestrIcon32Regular } from './GovKoRosreestrIcon32Regular';
import { GovKoRosreestrIcon64Regular } from './GovKoRosreestrIcon64Regular';
var sizes = {
    16: {
        light: GovKoRosreestrIcon16Light,
        regular: GovKoRosreestrIcon16Regular,
        solid: GovKoRosreestrIcon16Solid,
    },
    20: {
        light: GovKoRosreestrIcon20Light,
        regular: GovKoRosreestrIcon20Regular,
        solid: GovKoRosreestrIcon20Solid,
    },
    24: {
        regular: GovKoRosreestrIcon24Regular,
        solid: GovKoRosreestrIcon24Solid,
    },
    32: {
        regular: GovKoRosreestrIcon32Regular,
    },
    64: {
        regular: GovKoRosreestrIcon64Regular,
    },
};
export var GovKoRosreestrIcon = forwardRef('GovKoRosreestrIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
